import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const CommsCenter = withLazyFallback(() => import('components/practice/CommsCenter/CommsCenter'));
const ContactsPage = withLazyFallback(
  () => import('components/practice/CommsCenter/components/Contacts/Contacts')
);
const NewArchivedFaxes = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/ArchivedFaxes/NewArchivedFaxes')
);

const DraftFaxes = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/Drafts/DraftFaxes')
);
const Fax = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/Fax/Fax')
);
const NewInboundFaxes = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/InboundFaxes/NewInboundFaxes')
);
const Main = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/Main/Main')
);
const NewOutboundFaxes = withLazyFallback(
  () => import('components/practice/CommsCenter/components/fax/OutboundFaxes/NewOutboundFaxes')
);
const Messages = withLazyFallback(
  () => import('components/practice/CommsCenter/components/messages/Messages')
);

const PRACTICE_COMMS_CENTER = [
  {
    path: 'comms-center',
    element: <CommsCenter />,
    handle: { title: 'Comms Center' },
    children: [
      {
        path: '',
        element: <Fax />,
        children: [
          { path: '', element: <Main />, handle: { title: 'Fax' } },
          { path: 'inbound', element: <NewInboundFaxes />, handle: { title: 'Inbound faxes' } },
          { path: 'outbound', element: <NewOutboundFaxes />, handle: { title: 'Outbound faxes' } },
          { path: 'drafts', element: <DraftFaxes />, handle: { title: 'Drafts' } },
          { path: 'archived', element: <NewArchivedFaxes />, handle: { title: 'Archived' } }
        ]
      },
      { path: 'messages', element: <Messages />, handle: { title: 'Messages' } },
      { path: 'contacts', element: <ContactsPage />, handle: { title: 'Contacts' } }
    ]
  }
];

export default PRACTICE_COMMS_CENTER;
